module.exports = __webpack_public_path__ + "img/center-bg.d9c4554b.png";